// extracted by mini-css-extract-plugin
export var content = "_ml-1";
export var divider = "_ml-0";